import React, { FC } from 'react'
import { ThemeProvider } from '@xstyled/styled-components'
import defaultTheme from '@mailstep/design-system/ui/ThemeProvider/themes/default'
import darkTheme from '@mailstep/design-system/ui/ThemeProvider/themes/dark'
import { useThemeMode } from '@contexts/ThemeModeContext/hooks/useThemeMode'
import { ResolvedTheme } from '@contexts/ThemeModeContext/ThemeModeContext'

type Props = {
  children: React.ReactNode
}

export const ThemedApp: FC<Props> = ({ children }) => {
  const { resolvedTheme } = useThemeMode()
  const theme = resolvedTheme === ResolvedTheme.Dark ? darkTheme : defaultTheme

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
